import React from "react";
const Msgalert = ({ message, status }) => {
  return (
    <>
      <div
        className={"m-2 alert alert-" + (status === 200 ? "success" : "danger")}
        role="alert"
      >
        {message}
      </div>
    </>
  );
};
export default Msgalert;
